import config from './config';

function checkIpv4CidrIsOverlapApi(params) {
	return Ajax.get(config.checkIpv4CidrIsOverlap, params);	
}

function getPeeringQuotaApi(params) {
	return Ajax.get(config.peeringQuota, params);
}

function getPeerRegionsApi(params) {
	return Ajax.get(config.peerRegions, params);
}

function addPeerConnApi(params) {
	return Ajax.post(config.addPeerConn, params, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
}


export {
	checkIpv4CidrIsOverlapApi,
	getPeeringQuotaApi,
	getPeerRegionsApi,
	addPeerConnApi
};


// WEBPACK FOOTER //
// ./src/api/peering/create/actions.js